import UrqlClient from '../client';
import { getSdk } from './sdk.access-control';

if (!import.meta.env.VITE_APP_ENDPOINT) new Error('Нет переменной VITE_APP_ENDPOINT');

const client = new UrqlClient(`${import.meta.env.VITE_APP_ENDPOINT}/mobile/ob-access-control-service/graphql`);
const sdkAccessControlService = getSdk(client);

export * from './sdk.access-control';
export default sdkAccessControlService;
